export default {
  mock: {
    config: {},
    headers: {},
    status: 200,
    statusText: '',
    data: {
      serviceName: "アイラ地域サポート",
      serviceAttributeTypes: [
        {
          attributeTypeId: 1,
          attributeTypeUUID: "attributetypes001",
          attributeTypeName: "町内会",
          deliveryTypeCode: "chonaikai",
          attributeCounts: 9,
          deliveryFlg: true,
          attributeTypeStatus: 1,
          attributeGroups: [
            {
              attributeGroupUuid: "attributegroup002", 
              attributeGroupOrder: 2,
              attributeGroupName: "〇〇町内会",
              attributeGroupCode: "marumaru",
              attributeGroupMailAddress: "aaa@aaa.com"
            },
            {
              attributeGroupUuid: "attributegroup001", 
              attributeGroupOrder: 1,
              attributeGroupName: "△△町内会",
              attributeGroupCode: "sankaku",
              attributeGroupMailAddress: "bbb@bbb.com"
            }
          ] 
        },
        {
          attributeTypeId: 2,
          attributeTypeUUID: "attributetypes002",
          attributeTypeName: "学校",
          deliveryTypeCode: "school",
          attributeCounts: 4,
          deliveryFlg: false,
          attributeTypeStatus: 1,
          attributeGroups: [
            {
              attributeGroupUuid: "attributegroup008", 
              attributeGroupOrder: 8,
              attributeGroupName: "高校",
              attributeGroupCode: "koukou",
              attributeGroupMailAddress: "koukou@aaa.com"
            },
            {
              attributeGroupUuid: "attributegroup006", 
              attributeGroupOrder: 6,
              attributeGroupName: "中学",
              attributeGroupCode: "chugaku",
              attributeGroupMailAddress: "chugaku@bbb.com"
            }
          ] 
        }
      ]
    }
  }
}